import { Controller } from 'stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static targets = ['dragContainer'];

  connect() {
    this.scrollSpeed = 10;
    this.scrollThreshold = 100;
    this.isDragging = false;
    this.scrollRequest = null;
    this.isTouchDevice = 'ontouchstart' in document.documentElement;
    this.startIndex = null;
    this.sortables = [];
    this.initSortable();
    document.addEventListener("turbo:load", () => this.initSortable());
    window.addEventListener("resize", this.handleResize.bind(this));
  }

  disconnect() {
    window.removeEventListener("resize", () => this.handleResize.bind(this));
  }

  handleResize() {
    this.destroySortable();
    this.initSortable();
  }

  destroySortable() {
    this.sortables.forEach((sortable) => sortable.destroy());
  }

  initSortable() {
    this.sortables = this.dragContainerTargets.map(container => {
      return new Sortable(container, {
        handle: '.drag-icons-dots',
        draggable: 'li',
        animation: 150,
        scroll: true,
        scrollSensitivity: 100,
        scrollSpeed: 10,
        ghostClass: 'sortable-ghost',
        forceFallback: false,
        fallbackClass: "sortable-fallback",
        onStart: (event) => this.onDragStart(event),
        onEnd: (event) => this.onDragEnd(event),
        onUpdate: (event) => this.onDrop(event),
      });
    });
  }

  onDragStart(event) {
    this.isDragging = true;
    this.startIndex = event.oldIndex;
    this.trackMouseMove();
    document.body.style.overflow = 'auto';
    document.addEventListener("dragover", this.autoScroll.bind(this));
  }

  onDragEnd(event) {
    this.isDragging = false;
    this.stopAutoScroll();
    document.body.style.overflow = 'auto';
    document.removeEventListener("dragover", this.autoScroll.bind(this));
  }

  onDrop(event) {

    const el = event.item;
    const target = event.to;
    const sibling = event.item.nextElementSibling;
    
    this.changePosition(el, target, event.from, sibling);
  }

  trackMouseMove() {
    this.stopAutoScroll();

    if (this.isTouchDevice) {
      document.addEventListener('touchmove', this.handleTouchMove.bind(this), { passive: false });
    }
  }

  autoScroll(event) {
    if (!this.isDragging) return;
    let clientY = event.clientY;
    const viewportHeight = window.innerHeight;

    if (clientY < this.scrollThreshold){
      this.startAutoScroll(-this.scrollSpeed);
    } else if (clientY > viewportHeight - this.scrollThreshold) {
      this.startAutoScroll(this.scrollSpeed);
    } else {
      this.stopAutoScroll();
    }
  }

  handleTouchMove(event) {
    if (!this.isDragging) return;

    const clientY = event.touches[0].clientY;
    const viewportHeight = window.innerHeight;

    if (clientY < this.scrollThreshold || clientY > viewportHeight - this.scrollThreshold) {
      event.preventDefault();
    }

    this.autoScroll({ clientY });
  }

  startAutoScroll(speed) {
    if (this.scrollRequest) return;

    const scrollStep = () => {
      if (!this.isDragging) {
        this.stopAutoScroll();
        return;
      }
      document.documentElement.scrollTop += speed;
      this.scrollRequest = requestAnimationFrame(scrollStep);
    };

    this.scrollRequest = requestAnimationFrame(scrollStep);
  }

  stopAutoScroll() {
    if (this.scrollRequest) {
      cancelAnimationFrame(this.scrollRequest);
      this.scrollRequest = null;
    }
  }

  changePosition(el, target, source, sibling) {
    var processTemplateId = this.element.getAttribute("data-process-template-id");
    var elementId = el.getAttribute("data-step-id")
    var siblingId = null;

    if(sibling !== null) {
      siblingId = sibling.getAttribute("data-step-id")
    }
    let data = { id: elementId, sibling_id: siblingId };

    fetch(`/${accountId}/process_templates/${processTemplateId}/step_templates/${elementId}/update_position`, {
      method: "PATCH",
      body: JSON.stringify(data),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (!response.ok) {
        throw response
      }
      return response.json();
    }).then((responseJson) => {
      if(responseJson.sibling_present === true) {
        sibling = el.previousElementSibling
      }

      let elStepSettings = el.querySelector(".meta-item.step-settings-item");
      let siblingStepSettings = sibling.querySelector(".meta-item.step-settings-item");
      elStepSettings.innerHTML = responseJson.current_task_setting;
      siblingStepSettings.innerHTML = responseJson.sibling_task_setting;
    }).catch((error) => {
      console.log(error)
    })
  }

}